module.exports = __webpack_public_path__ + "img/avatar-04.DHchhNLz.47283776.jpg";